import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditCgp({
  backUrl,
  api,
  fetchData,
  getType,
  getPP,
  getTypePersonne,
  getPM,
  getTeteReseau,
  getTaux,
  getModele,
  getCodeInvest,
  getTypeProduction,
  getAnnee,
  getSecteurActivite,
  getValue,
  getContact,
  getSociete,
  getSituationMatrimonial,
  //render
  renderSocieteOptions,
  renderContactOptions,
  renderOuiNonOptions,
  renderPmOptions,
  renderTauxOptions,
  renderTeteReseauOptions,
  renderTypePersonneOptions,
  renderPpOptions,
  renderModeleOptions,
  renderTypeOptions,
  renderCodeOptions,
  renderTypeProductionOptions,
  renderSecteurActiviteOptions,
  renderSituationMatrimonialOptions,

  // handle
  handleCodeChange,
  handleActifChange,
  handleTauxChange,
  handleTypeChange,
  handleTypePersonneChange,
  handleDefautChange,
  handleCompteCreanceChange,
  handleTrigrammeChange,
  handlePersonneChange,
  handlePmChange,
  handleNumeroChange,
  handleTeteReseauChange,
  handleEntrepreteurChange,
  handleModeleChange,
  handleModeleTChange,
  handleOrigineChange,
  handleEmailDeContactChange,
  handleCodeInvesChange,
  handleSocieteChange,
  //exploitant
  handleComptableChange,
  handleDataCreaChange,
  handleDateEntreeChange,
  handleImpactChange,
  handleMatChange,
  handleSecteurChange,
  handleSecteurActiviteChange,
  handleSurfaceConsChange,
  handleSurfaceExpChange,
  handleSurfaceTotChange,
  handleTypeProductionChange,
  formDonneesFinanciere,
  onAddFormDonneesFinanciere,
  onDeleteFormDonneesFinanciere,
  renderAnneeOptions,
  handleInputFinanceChange,
  formDonneesInvest,
  onAddFormDonneesInvest,
  onDeleteFormDonneesInvest,
  handleInputInvestChange,

  // requete
  handleSubmitP,
  handleSubmitPm,
  //variables
  selectedTaux,
  selectedActif,
  selectedCode,
  debounceCode,
  selectedCompteCreance,
  selectedDefaut,
  selectedEntrepreteur,
  selectedModele,
  selectedModeleT,
  selectedNumero,
  selectedOrigine,
  selectedEmailDeContact,
  selectedPersonnePhysique,
  selectedPm,
  selectedTeteReseau,
  selectedTrigramme,
  selectedType,
  selectedTypePersonne,
  // exploitant
  selectedComptable,
  selectedDataCrea,
  selectedDateEntree,
  selectedImpact,
  selectedMat,
  selectedSecteur,
  selectedSecteurActivite,
  selectedSurfaceCons,
  selectedSurfaceExp,
  selectedSurfaceTot,
  selectedTypeProduction,
  //Direction produit
  selectedCodeInves,
  // variable données
  IdentificationData,
  DonneesComplementData,
  DonneesComplementDirectionData,
  DonneesComplementExploitantData,
  hmfData1,
  hmfData2,
  value,
  setValue,
  value1,
  setValue1,
  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  // modal
  getTitre,
  getPay,
  handleSave,
  handleSave1,
  titreId,
  nom,
  prenom,
  dateDeNaissance,
  villeDeNaissance,
  ville,
  ville1,
  departementOuPays,
  profession,
  adresse,
  adresse1,
  complement,
  codePostal,
  codePostal1,
  payId,
  payId1,
  telFix,
  telMobil,
  emailPro,
  emailPerso,
  email,
  fax,
  telephone,
  raisonSociale,
  setPayId,
  handlePayIdChange,
  renderPaysOptions,
  renderTitreOptions,
  modalOpen,
  modalOpen1,
  toggleModal,
  toggleModal1,
  handleTitreIdChange,
  setRaisonSociale,
  setEmail,
  setEmailPro,
  handleSituationMatrimonialChange,
  setEmailPerso,
  setNom,
  setTelephone,
  setFax,
  setAdresse,
  setAdresse1,
  setCodePostal,
  setCodePostal1,
  setVille,
  setVille1,
  setPrenom,
  setDateDeNaissance,
  setVilleDeNaissance,
  setDepartementOuPays,
  setProfession,
  setComplement,
  setTelFix,
  setTelMobil,
  forceRender,
  forceRender1,
  forceRender2,
  forceRender3,
}) {
  const { id } = useParams();
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchData();
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchDataAsync();
  }, []);

  useEffect(() => {
    if (!loading) {
      getType();
      getContact();
      getTypePersonne();
      // getPM();
      getPP();
      getTeteReseau();
      getTaux();
      getModele();
      getCodeInvest();
      getTypeProduction();
      getAnnee();
      getTitre();
      getPay();
      getSecteurActivite();
      getSociete();
      getSituationMatrimonial();
    }
  }, [loading]);

  useEffect(() => {
    if (value?.length > 1) {
      getPP(value);
    }
  }, [loading, value]);
  useEffect(() => {
    if (value1?.length > 1) {
      getPM(value1);
    }
  }, [loading, value1]);
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          Titre
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={
                            selectedTypePersonne?.label == "PP"
                              ? handleSubmitP
                              : handleSubmitPm
                          }
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Identification
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(IdentificationData).map(
                                      ([key, value], index) => (
                                        <Row className="mb-2" key={index}>
                                          {key === "Type" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Type"
                                                  defaultValue={
                                                    selectedType?.label == null
                                                      ? null
                                                      : selectedType
                                                  }
                                                  onChange={handleTypeChange}
                                                  options={renderTypeOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedType == null
                                                  )}
                                                  isDisabled={
                                                    type_compte ===
                                                    "partenaire_premium"
                                                  }
                                                />
                                                {selectedType === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Type ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Personne Physique" &&
                                            selectedTypePersonne?.label ==
                                              "PP" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6 d-flex align-items-center">
                                                <Select
                                                  key={forceRender2}
                                                  onInputChange={setValue}
                                                  defaultValue={
                                                    selectedPersonnePhysique?.label ==
                                                    null
                                                      ? null
                                                      : selectedPersonnePhysique
                                                  }
                                                  placeholder="Taper pour rechercher ..."
                                                  onChange={
                                                    handlePersonneChange
                                                  }
                                                  options={renderPpOptions()}
                                                  isClearable={true}
                                                  className="select2 flex-grow-1"
                                                  styles={styles(false)}
                                                />
                                                {type_compte !=
                                                  "partenaire_premium" && (
                                                  <Button
                                                    onClick={toggleModal1}
                                                    className="btn btn-sm btn-light ms-2"
                                                  >
                                                    +
                                                  </Button>
                                                )}
                                              </Col>
                                              {selectedPersonnePhysique ===
                                              null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Personne physique ne peut pas
                                                  être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                              <Modal
                                                isOpen={modalOpen1}
                                                toggle={toggleModal1}
                                              >
                                                <ModalHeader
                                                  toggle={toggleModal1}
                                                >
                                                  Ajouter une nouvelle personne
                                                  physique
                                                </ModalHeader>
                                                <ModalBody>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Nom</label>
                                                      <input
                                                        type="text"
                                                        value={nom}
                                                        onChange={(e) =>
                                                          setNom(e.target.value)
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Prénom</label>
                                                      <input
                                                        type="text"
                                                        value={prenom}
                                                        onChange={(e) =>
                                                          setPrenom(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Titre</label>
                                                      <Select
                                                        placeholder="Selectionner un titre"
                                                        defaultValue={
                                                          titreId?.label == null
                                                            ? null
                                                            : titreId
                                                        }
                                                        onChange={
                                                          handleTitreIdChange
                                                        }
                                                        options={renderTitreOptions()}
                                                        isClearable={true}
                                                        className="select2 flex-grow-1"
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Société</label>
                                                      <Select
                                                        placeholder="Selectionner une societe"
                                                        defaultValue={
                                                          titreId?.label == null
                                                            ? null
                                                            : titreId
                                                        }
                                                        onChange={
                                                          handleSocieteChange
                                                        }
                                                        options={renderSocieteOptions()}
                                                        isClearable={true}
                                                        className="select2 flex-grow-1"
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>

                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Date de naissance
                                                      </label>
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={dateDeNaissance}
                                                        onChange={(e) =>
                                                          setDateDeNaissance(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                        placeholder="JJ/MM/AAAA"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>
                                                        Ville de naissance
                                                      </label>
                                                      <input
                                                        type="text"
                                                        value={villeDeNaissance}
                                                        onChange={(e) =>
                                                          setVilleDeNaissance(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Departement de naissance
                                                      </label>
                                                      <input
                                                        type="text"
                                                        value={
                                                          departementOuPays
                                                        }
                                                        onChange={(e) =>
                                                          setDepartementOuPays(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Profession</label>
                                                      <input
                                                        type="text"
                                                        value={profession}
                                                        onChange={(e) =>
                                                          setProfession(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Situation matrimoniale
                                                      </label>
                                                      <Select
                                                        placeholder="Selectionner situtation matrimoniale"
                                                        defaultValue={
                                                          titreId?.label == null
                                                            ? null
                                                            : titreId
                                                        }
                                                        onChange={
                                                          handleSituationMatrimonialChange
                                                        }
                                                        options={renderSituationMatrimonialOptions()}
                                                        isClearable={true}
                                                        className="select2 flex-grow-1"
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Adresse</label>
                                                      <input
                                                        type="text"
                                                        value={adresse1}
                                                        onChange={(e) =>
                                                          setAdresse1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Complément</label>
                                                      <input
                                                        type="text"
                                                        value={complement}
                                                        onChange={(e) =>
                                                          setComplement(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Code postal</label>
                                                      <input
                                                        type="text"
                                                        value={codePostal1}
                                                        onChange={(e) =>
                                                          setCodePostal1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Ville</label>
                                                      <input
                                                        type="text"
                                                        value={ville1}
                                                        onChange={(e) =>
                                                          setVille1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Pays</label>
                                                      <Select
                                                        placeholder="Sélectionner un pays"
                                                        defaultValue={
                                                          payId1?.label == null
                                                            ? null
                                                            : payId1
                                                        }
                                                        onChange={
                                                          handlePayIdChange
                                                        }
                                                        options={renderPaysOptions()}
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                        isClearable={true}
                                                        className="select2"
                                                      />{" "}
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Email professionnel
                                                      </label>
                                                      <input
                                                        type="email"
                                                        value={emailPro}
                                                        onChange={(e) =>
                                                          setEmailPro(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Email perso</label>
                                                      <input
                                                        type="email"
                                                        value={emailPerso}
                                                        onChange={(e) =>
                                                          setEmailPerso(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                      {emailPerso?.trim() ===
                                                        "" && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            fontSize: "12px",
                                                            marginTop: "5px",
                                                          }}
                                                        >
                                                          Ce champ est
                                                          obligatoire.
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Téléphone mobile
                                                      </label>
                                                      <input
                                                        type="tel"
                                                        value={telMobil}
                                                        onChange={(e) =>
                                                          setTelMobil(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                        required
                                                      />
                                                      {telMobil?.trim() ===
                                                        "" && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            fontSize: "12px",
                                                            marginTop: "5px",
                                                          }}
                                                        >
                                                          Ce champ est
                                                          obligatoire.
                                                        </div>
                                                      )}
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>
                                                        Téléphone fixe
                                                      </label>
                                                      <input
                                                        type="tel"
                                                        value={telFix}
                                                        onChange={(e) =>
                                                          setTelFix(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                </ModalBody>
                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    onClick={handleSave1}
                                                  >
                                                    Enregistrer
                                                  </Button>
                                                  <Button
                                                    color="secondary"
                                                    onClick={toggleModal1}
                                                  >
                                                    Annuler
                                                  </Button>
                                                </ModalFooter>
                                              </Modal>
                                            </>
                                          ) : (key === "Personne Morale" &&
                                              selectedTypePersonne?.label ==
                                                "PM") ||
                                            (key === "Personne Morale" &&
                                              selectedTypePersonne?.label !=
                                                "PM" &&
                                              selectedTypePersonne?.label !=
                                                "PP") ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6 d-flex align-items-center">
                                                <Select
                                                  key={forceRender}
                                                  onInputChange={setValue1}
                                                  placeholder="Taper pour rechercher ..."
                                                  defaultValue={
                                                    selectedPm?.label == null
                                                      ? null
                                                      : selectedPm
                                                  }
                                                  onChange={handlePmChange}
                                                  options={renderPmOptions()}
                                                  isClearable={true}
                                                  className="select2 flex-grow-1"
                                                  styles={styles(false)}
                                                  isDisabled={
                                                    type_compte ===
                                                    "partenaire_premium"
                                                  }
                                                />{" "}
                                                {type_compte !=
                                                  "partenaire_premium" && (
                                                  <Button
                                                    onClick={toggleModal}
                                                    className="btn btn-sm btn-light ms-2"
                                                  >
                                                    +
                                                  </Button>
                                                )}
                                              </Col>{" "}
                                              {selectedPm === null ||
                                              selectedPm === "" ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Personne Morale ne peut pas
                                                  être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                              <Modal
                                                isOpen={modalOpen}
                                                toggle={toggleModal}
                                              >
                                                <ModalHeader
                                                  toggle={toggleModal}
                                                >
                                                  Ajouter une nouvelle personne
                                                  morale
                                                </ModalHeader>
                                                <ModalBody>
                                                  <FormGroup>
                                                    <Label for="raisonSociale">
                                                      Raison sociale
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="raisonSociale"
                                                      id="raisonSociale"
                                                      value={raisonSociale}
                                                      onChange={(e) =>
                                                        setRaisonSociale(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="email">
                                                      Email
                                                    </Label>
                                                    <Input
                                                      type="email"
                                                      name="email"
                                                      id="email"
                                                      value={email}
                                                      onChange={(e) =>
                                                        setEmail(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="telephone">
                                                      Téléphone
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="telephone"
                                                      id="telephone"
                                                      value={telephone}
                                                      onChange={(e) =>
                                                        setTelephone(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="fax">Fax</Label>
                                                    <Input
                                                      type="text"
                                                      name="fax"
                                                      id="fax"
                                                      value={fax}
                                                      onChange={(e) =>
                                                        setFax(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="adresse">
                                                      Adresse
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="adresse"
                                                      id="adresse"
                                                      value={adresse}
                                                      onChange={(e) =>
                                                        setAdresse(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="codePostal">
                                                      Code postal
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="codePostal"
                                                      id="codePostal"
                                                      value={codePostal}
                                                      onChange={(e) =>
                                                        setCodePostal(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="ville">
                                                      Ville
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="ville"
                                                      id="ville"
                                                      value={ville}
                                                      onChange={(e) =>
                                                        setVille(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="payId">
                                                      Pays
                                                    </Label>
                                                    <Select
                                                      placeholder="Sélectionnez le pays"
                                                      defaultValue={
                                                        payId?.label == null
                                                          ? null
                                                          : payId
                                                      }
                                                      onChange={setPayId}
                                                      options={renderPaysOptions()}
                                                      styles={{
                                                        menu: (
                                                          provided,
                                                          state
                                                        ) => ({
                                                          ...provided,
                                                          backgroundColor:
                                                            "white",
                                                        }),
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </ModalBody>
                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    onClick={handleSave}
                                                  >
                                                    Enregistrer
                                                  </Button>
                                                  <Button
                                                    color="secondary"
                                                    onClick={toggleModal}
                                                  >
                                                    Annuler
                                                  </Button>
                                                </ModalFooter>
                                              </Modal>
                                            </>
                                          ) : key === "Personne Morale" &&
                                            selectedTypePersonne?.label ==
                                              "PP" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>
                                                    Personne Physique* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6 d-flex align-items-center">
                                                <Select
                                                  key={forceRender1}
                                                  onInputChange={setValue}
                                                  defaultValue={
                                                    selectedPersonnePhysique?.label ==
                                                    null
                                                      ? null
                                                      : selectedPersonnePhysique
                                                  }
                                                  placeholder="Taper pour rechercher ..."
                                                  onChange={
                                                    handlePersonneChange
                                                  }
                                                  options={renderPpOptions()}
                                                  isClearable={true}
                                                  className="select2 flex-grow-1"
                                                  styles={styles(false)}
                                                />
                                                {type_compte !=
                                                  "partenaire_premium" && (
                                                  <Button
                                                    onClick={toggleModal1}
                                                    className="btn btn-sm btn-light ms-2"
                                                  >
                                                    +
                                                  </Button>
                                                )}
                                              </Col>{" "}
                                              {selectedPersonnePhysique ===
                                              null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Personne physique ne peut pas
                                                  être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                              <Modal
                                                isOpen={modalOpen1}
                                                toggle={toggleModal1}
                                              >
                                                <ModalHeader
                                                  toggle={toggleModal1}
                                                >
                                                  Ajouter une nouvelle personne
                                                  physique
                                                </ModalHeader>
                                                <ModalBody>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Titre</label>
                                                      <Select
                                                        placeholder="Selectionner un titre"
                                                        defaultValue={
                                                          titreId?.label == null
                                                            ? null
                                                            : titreId
                                                        }
                                                        onChange={
                                                          handleTitreIdChange
                                                        }
                                                        options={renderTitreOptions()}
                                                        isClearable={true}
                                                        className="select2 flex-grow-1"
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Nom</label>
                                                      <input
                                                        type="text"
                                                        value={nom}
                                                        onChange={(e) =>
                                                          setNom(e.target.value)
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Prénom</label>
                                                      <input
                                                        type="text"
                                                        value={prenom}
                                                        onChange={(e) =>
                                                          setPrenom(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Date de naissance
                                                      </label>
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={dateDeNaissance}
                                                        onChange={(e) =>
                                                          setDateDeNaissance(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                        placeholder="JJ/MM/AAAA"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>
                                                        Ville de naissance
                                                      </label>
                                                      <input
                                                        type="text"
                                                        value={villeDeNaissance}
                                                        onChange={(e) =>
                                                          setVilleDeNaissance(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Departement ou Pays
                                                      </label>
                                                      <input
                                                        type="text"
                                                        value={
                                                          departementOuPays
                                                        }
                                                        onChange={(e) =>
                                                          setDepartementOuPays(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Profession</label>
                                                      <input
                                                        type="text"
                                                        value={profession}
                                                        onChange={(e) =>
                                                          setProfession(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Adresse</label>
                                                      <input
                                                        type="text"
                                                        value={adresse1}
                                                        onChange={(e) =>
                                                          setAdresse1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Complément</label>
                                                      <input
                                                        type="text"
                                                        value={complement}
                                                        onChange={(e) =>
                                                          setComplement(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Code postal</label>
                                                      <input
                                                        type="text"
                                                        value={codePostal1}
                                                        onChange={(e) =>
                                                          setCodePostal1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>Ville</label>
                                                      <input
                                                        type="text"
                                                        value={ville1}
                                                        onChange={(e) =>
                                                          setVille1(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>Pays</label>
                                                      <Select
                                                        placeholder="Sélectionner un pays"
                                                        defaultValue={
                                                          payId1?.label == null
                                                            ? null
                                                            : payId1
                                                        }
                                                        onChange={
                                                          handlePayIdChange
                                                        }
                                                        options={renderPaysOptions()}
                                                        styles={{
                                                          menu: (
                                                            provided,
                                                            state
                                                          ) => ({
                                                            ...provided,
                                                            backgroundColor:
                                                              "white",
                                                          }),
                                                        }}
                                                        isClearable={true}
                                                        className="select2"
                                                      />{" "}
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>
                                                        Téléphone fixe
                                                      </label>
                                                      <input
                                                        type="tel"
                                                        value={telFix}
                                                        onChange={(e) =>
                                                          setTelFix(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                  <Row className="mb-2">
                                                    <Col md={6}>
                                                      <label>
                                                        Téléphone mobile
                                                      </label>
                                                      <input
                                                        type="tel"
                                                        value={telMobil}
                                                        onChange={(e) =>
                                                          setTelMobil(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                    <Col md={6}>
                                                      <label>
                                                        Email professionnel
                                                      </label>
                                                      <input
                                                        type="email"
                                                        value={emailPro}
                                                        onChange={(e) =>
                                                          setEmailPro(
                                                            e.target.value
                                                          )
                                                        }
                                                        className="form-control form-control-sm"
                                                      />
                                                    </Col>
                                                  </Row>
                                                </ModalBody>
                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    onClick={handleSave1}
                                                  >
                                                    Enregistrer
                                                  </Button>
                                                  <Button
                                                    color="secondary"
                                                    onClick={toggleModal1}
                                                  >
                                                    Annuler
                                                  </Button>
                                                </ModalFooter>
                                              </Modal>
                                            </>
                                          ) : key === "Personne Physique" &&
                                            selectedTypePersonne?.label ==
                                              "PM" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>
                                                    Personne Morale* :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6 d-flex align-items-center">
                                                <Select
                                                  key={forceRender}
                                                  onInputChange={setValue1}
                                                  placeholder="Taper pour rechercher ..."
                                                  defaultValue={
                                                    selectedPm?.label == null
                                                      ? null
                                                      : selectedPm
                                                  }
                                                  onChange={handlePmChange}
                                                  options={renderPmOptions()}
                                                  isClearable={true}
                                                  className="select2 flex-grow-1"
                                                  styles={styles(false)}
                                                />{" "}
                                                {type_compte !=
                                                  "partenaire_premium" && (
                                                  <Button
                                                    onClick={toggleModal}
                                                    className="btn btn-sm btn-light ms-2"
                                                  >
                                                    +
                                                  </Button>
                                                )}
                                                {selectedPm === null ||
                                                selectedPm === "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Personne Morale ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>

                                              <Modal
                                                isOpen={modalOpen}
                                                toggle={toggleModal}
                                              >
                                                <ModalHeader
                                                  toggle={toggleModal}
                                                >
                                                  Ajouter une nouvelle personne
                                                  morale
                                                </ModalHeader>
                                                <ModalBody>
                                                  <FormGroup>
                                                    <Label for="raisonSociale">
                                                      Raison sociale
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="raisonSociale"
                                                      id="raisonSociale"
                                                      value={raisonSociale}
                                                      onChange={(e) =>
                                                        setRaisonSociale(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="email">
                                                      Email
                                                    </Label>
                                                    <Input
                                                      type="email"
                                                      name="email"
                                                      id="email"
                                                      value={email}
                                                      onChange={(e) =>
                                                        setEmail(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="telephone">
                                                      Téléphone
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="telephone"
                                                      id="telephone"
                                                      value={telephone}
                                                      onChange={(e) =>
                                                        setTelephone(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="fax">Fax</Label>
                                                    <Input
                                                      type="text"
                                                      name="fax"
                                                      id="fax"
                                                      value={fax}
                                                      onChange={(e) =>
                                                        setFax(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="adresse">
                                                      Adresse
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="adresse"
                                                      id="adresse"
                                                      value={adresse}
                                                      onChange={(e) =>
                                                        setAdresse(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="codePostal">
                                                      Code postal
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="codePostal"
                                                      id="codePostal"
                                                      value={codePostal}
                                                      onChange={(e) =>
                                                        setCodePostal(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="ville">
                                                      Ville
                                                    </Label>
                                                    <Input
                                                      type="text"
                                                      name="ville"
                                                      id="ville"
                                                      value={ville}
                                                      onChange={(e) =>
                                                        setVille(e.target.value)
                                                      }
                                                    />
                                                  </FormGroup>
                                                  <FormGroup>
                                                    <Label for="payId">
                                                      Pays
                                                    </Label>
                                                    <Select
                                                      placeholder="Sélectionnez le pays"
                                                      defaultValue={
                                                        payId?.label == null
                                                          ? null
                                                          : payId
                                                      }
                                                      onChange={setPayId}
                                                      options={renderPaysOptions()}
                                                      styles={{
                                                        menu: (
                                                          provided,
                                                          state
                                                        ) => ({
                                                          ...provided,
                                                          backgroundColor:
                                                            "white",
                                                        }),
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </ModalBody>
                                                <ModalFooter>
                                                  <Button
                                                    color="primary"
                                                    onClick={handleSave}
                                                  >
                                                    Enregistrer
                                                  </Button>
                                                  <Button
                                                    color="secondary"
                                                    onClick={toggleModal}
                                                  >
                                                    Annuler
                                                  </Button>
                                                </ModalFooter>
                                              </Modal>
                                            </>
                                          ) : key === "Type personne" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Type personne"
                                                  defaultValue={
                                                    selectedTypePersonne?.label ==
                                                    null
                                                      ? null
                                                      : selectedTypePersonne
                                                  }
                                                  onChange={
                                                    handleTypePersonneChange
                                                  }
                                                  options={renderTypePersonneOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedTypePersonne == null
                                                  )}
                                                />
                                                {selectedTypePersonne ===
                                                null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Type personne ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "N° RCS" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={selectedNumero}
                                                  required
                                                  onChange={handleNumeroChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Code APE" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  key={forceRender2}
                                                  className="form-control form-control-sm"
                                                  defaultValue={selectedCode}
                                                  required
                                                  onChange={handleCodeChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Date entrée en relation" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i
                                                  style={{
                                                    color: "#9d9c9c",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      display: "inline-block",
                                                      width: "8em",

                                                      whiteSpace: "wrap",
                                                    }}
                                                  >
                                                    {key} :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={selectedDateEntree}
                                                  className="form-control form-control-sm input-color"
                                                  onChange={
                                                    handleDateEntreeChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Actif" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Actif"
                                                  defaultValue={
                                                    selectedActif?.label == null
                                                      ? null
                                                      : selectedActif
                                                  }
                                                  onChange={handleActifChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedActif == null
                                                  )}
                                                  isDisabled={
                                                    type_compte ===
                                                    "partenaire_premium"
                                                  }
                                                />
                                                {selectedActif === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Actif ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key === "Défaut" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Défaut"
                                                  defaultValue={
                                                    selectedDefaut?.label ==
                                                    null
                                                      ? null
                                                      : selectedDefaut
                                                  }
                                                  onChange={handleDefautChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(false)}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Trigramme" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedTrigramme
                                                  }
                                                  required
                                                  onChange={
                                                    handleTrigrammeChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Tête de réseau" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Tête de réseau"
                                                  defaultValue={
                                                    selectedTeteReseau?.label ==
                                                    null
                                                      ? null
                                                      : selectedTeteReseau
                                                  }
                                                  onChange={
                                                    handleTeteReseauChange
                                                  }
                                                  options={renderTeteReseauOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedTeteReseau == null
                                                  )}
                                                  isDisabled={
                                                    type_compte ===
                                                    "partenaire_premium"
                                                  }
                                                />
                                                {selectedTeteReseau === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Tête de réseau ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      )
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                {DonneesComplementData ? (
                                  <Card
                                    className="mb-4"
                                    style={{
                                      display:
                                        DonneesComplementData.length >= 0
                                          ? "none"
                                          : "",
                                    }}
                                  >
                                    <CardTitle
                                      tag="h5"
                                      style={{ paddingLeft: "10px" }}
                                    >
                                      {" "}
                                      Données complémentaires CGP
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        DonneesComplementData
                                      ).map(([key, value], index) => (
                                        <Row className="mb-2" key={index}>
                                          {key === "Email de contact" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedEmailDeContact
                                                  }
                                                  onChange={
                                                    handleEmailDeContactChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Origine" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={selectedOrigine}
                                                  required
                                                  onChange={handleOrigineChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Taux d'apport (restriction)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Taux"
                                                  defaultValue={selectedTaux}
                                                  onChange={handleTauxChange}
                                                  options={renderTauxOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  isMulti={true}
                                                  styles={styles(false)}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Modèle dossier de souscription" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Modèle"
                                                  defaultValue={
                                                    selectedModele?.label ==
                                                    null
                                                      ? null
                                                      : selectedModele
                                                  }
                                                  onChange={handleModeleChange}
                                                  options={renderModeleOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(false)}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Modèle dossier de souscription TEPA" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Modèle"
                                                  defaultValue={
                                                    selectedModeleT?.label ==
                                                    null
                                                      ? null
                                                      : selectedModeleT
                                                  }
                                                  onChange={handleModeleTChange}
                                                  options={renderModeleOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(false)}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Entrepreteurs" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  placeholder="Séléctionner Entrepreteurs"
                                                  defaultValue={
                                                    selectedEntrepreteur?.label ==
                                                    null
                                                      ? null
                                                      : selectedEntrepreteur
                                                  }
                                                  onChange={
                                                    handleEntrepreteurChange
                                                  }
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(false)}
                                                />
                                              </Col>
                                            </>
                                          ) : null}{" "}
                                        </Row>
                                      ))}
                                    </CardBody>
                                  </Card>
                                ) : null}

                                <Row>
                                  <Col
                                    sm="12"
                                    style={{
                                      display:
                                        DonneesComplementDirectionData.length >=
                                        0
                                          ? "none"
                                          : "",
                                    }}
                                  >
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        {" "}
                                        Données complémentaires Direction
                                        produit
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(
                                          DonneesComplementDirectionData
                                        )?.map(([key, value], index) => (
                                          <Row className="mb-2" key={index}>
                                            {key === "Compte de créance" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedCompteCreance
                                                    }
                                                    required
                                                    onChange={
                                                      handleCompteCreanceChange
                                                    }
                                                  />
                                                </Col>
                                              </>
                                            ) : key ===
                                              "Code d'investissement par défaut" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{
                                                      color: "#9d9c9c",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "10em",

                                                        textWrap: "pretty",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    placeholder="Séléctionner Code"
                                                    defaultValue={
                                                      selectedCodeInves?.label ==
                                                      null
                                                        ? null
                                                        : selectedCodeInves
                                                    }
                                                    onChange={
                                                      handleCodeInvesChange
                                                    }
                                                    options={renderCodeOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                                {Object.keys(DonneesComplementExploitantData)
                                  .length > 0 ? (
                                  <Row>
                                    <Col sm="12">
                                      <Card className="mb-4">
                                        <CardTitle
                                          tag="h5"
                                          style={{
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          {" "}
                                          Données complémentaires exploitant
                                        </CardTitle>

                                        <CardBody>
                                          {Object.entries(
                                            DonneesComplementExploitantData
                                          ).map(([key, value], index) => (
                                            <Row className="mb-2" key={index}>
                                              {key ===
                                              "Matériel d'exploitation" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span>{key} :</span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={selectedMat}
                                                      required
                                                      onChange={handleMatChange}
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Comptable" && false ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <Select
                                                      placeholder="Sélection du comptable"
                                                      // onInputChange={setValue}
                                                      defaultValue={
                                                        selectedComptable?.label ==
                                                        null
                                                          ? null
                                                          : selectedComptable
                                                      }
                                                      onChange={
                                                        handleComptableChange
                                                      }
                                                      options={renderContactOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Date création activité" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <InputMask
                                                      mask="99/99/9999"
                                                      value={selectedDataCrea}
                                                      className="form-control form-control-sm input-color"
                                                      onChange={
                                                        handleDataCreaChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Types de production" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <Select
                                                      placeholder="Séléctionner Type de production"
                                                      defaultValue={
                                                        selectedTypeProduction?.label ==
                                                        null
                                                          ? null
                                                          : selectedTypeProduction
                                                      }
                                                      onChange={
                                                        handleTypeProductionChange
                                                      }
                                                      options={renderTypeProductionOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      isMulti={true}
                                                      styles={styles(false)}
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Secteur d'activité de l'exploitant" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span>{key} :</span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedSecteur
                                                      }
                                                      required
                                                      onChange={
                                                        handleSecteurChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}{" "}
                                              {key === "Secteur d'activité" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span>{key} :</span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <Select
                                                      key={forceRender3}
                                                      placeholder="Séléctionner"
                                                      defaultValue={
                                                        selectedSecteurActivite?.label ==
                                                        null
                                                          ? null
                                                          : selectedSecteurActivite
                                                      }
                                                      onChange={
                                                        handleSecteurActiviteChange
                                                      }
                                                      options={renderSecteurActiviteOptions()}
                                                      isClearable={true}
                                                      className="select2"
                                                      styles={styles(false)}
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface construite (m²)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "10em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedSurfaceCons
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceConsChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface exploitée (ha)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "9em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedSurfaceExp
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceExpChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key ===
                                              "Surface totale détenue (ha)" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "9em",

                                                          textWrap: "wrap",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedSurfaceTot
                                                      }
                                                      required
                                                      onChange={
                                                        handleSurfaceTotChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                              {key === "Impact sur l'emploi" ? (
                                                <>
                                                  <Col
                                                    xs={12}
                                                    md={12}
                                                    lg={4}
                                                    style={colStyle}
                                                  >
                                                    <i
                                                      style={{
                                                        color: "#9d9c9c",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          display:
                                                            "inline-block",
                                                          width: "11em",
                                                          paddingTop: "10px",
                                                        }}
                                                      >
                                                        {key} :
                                                      </span>
                                                    </i>
                                                  </Col>
                                                  <Col className="col-md-6">
                                                    <input
                                                      className="form-control form-control-sm"
                                                      defaultValue={
                                                        selectedImpact
                                                      }
                                                      required
                                                      onChange={
                                                        handleImpactChange
                                                      }
                                                    />
                                                  </Col>
                                                </>
                                              ) : null}
                                            </Row>
                                          ))}
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  </Row>
                                ) : null}
                              </Col>
                              <Col sm="12">
                                {hmfData1 ? (
                                  <>
                                    <Card className="mb-4">
                                      <CardTitle tag="h5">
                                        Données financières exploitant
                                      </CardTitle>
                                      <CardBody>
                                        <Col sm="12">
                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered rounded-3 overflow-hidden"
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  {hmfData1?.header?.map(
                                                    (columnName, index) => (
                                                      <th
                                                        className=""
                                                        style={tableaustyles}
                                                        key={index}
                                                      >
                                                        {columnName}
                                                      </th>
                                                    )
                                                  )}
                                                  <th
                                                    className=""
                                                    style={{
                                                      background: "#555B21",
                                                      color: "white",
                                                      paddingTop: "5px",
                                                      paddingBottom: "5px",
                                                      width: "1%",
                                                    }}
                                                    key="Del"
                                                  ></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formDonneesFinanciere &&
                                                  formDonneesFinanciere?.map(
                                                    (rowData) => (
                                                      <tr key={rowData.index}>
                                                        {Object.entries(
                                                          rowData
                                                        ).map(([key, value]) =>
                                                          key !== "id" &&
                                                          key !== "index" ? (
                                                            <td key={key}>
                                                              {key ===
                                                              "annee_id" ? (
                                                                <select
                                                                  value={value}
                                                                  name="annee_id"
                                                                  className="form-control form-control-sm"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputFinanceChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                >
                                                                  {renderAnneeOptions()}
                                                                </select>
                                                              ) : key ===
                                                                "capitaux_propres" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="number"
                                                                  step="0.1"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputFinanceChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "produits_exploitation" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="number"
                                                                  step="0.1"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputFinanceChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "charges_exploitation" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="number"
                                                                  step="0.1"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputFinanceChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : key ===
                                                                "resultat_exploitation" ? (
                                                                <input
                                                                  className="form-control form-control-sm"
                                                                  type="number"
                                                                  step="0.1"
                                                                  defaultValue={
                                                                    value
                                                                  }
                                                                  name={key}
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    handleInputFinanceChange(
                                                                      rowData.index,
                                                                      e.target
                                                                        .name,
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                />
                                                              ) : (
                                                                <span>
                                                                  {value}
                                                                </span>
                                                              )}
                                                            </td>
                                                          ) : (
                                                            <td
                                                              className="d-none"
                                                              key={key}
                                                            >
                                                              <input
                                                                type="hidden"
                                                                value={value}
                                                              />
                                                            </td>
                                                          )
                                                        )}
                                                        <td>
                                                          <i
                                                            className="bx bx-trash"
                                                            style={{
                                                              fontSize: "20px",
                                                              paddingTop: "5px",
                                                              textAlign:
                                                                "center",
                                                              verticalAlign:
                                                                "middle",
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              onDeleteFormDonneesFinanciere(
                                                                rowData.index
                                                              )
                                                            }
                                                          ></i>
                                                        </td>
                                                      </tr>
                                                    )
                                                  )}
                                                <tr>
                                                  <td colSpan="9">
                                                    <input
                                                      type="button"
                                                      style={tableaustyles}
                                                      className="btn btn-info mt-3 mt-lg-0"
                                                      value="Ajouter"
                                                      onClick={
                                                        onAddFormDonneesFinanciere
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </Col>
                                      </CardBody>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col sm="12">
                                {hmfData2 ? (
                                  <>
                                    <Card className="mb-4">
                                      <CardTitle tag="h5">
                                        Données autres investissements
                                      </CardTitle>
                                      <CardBody>
                                        <Col sm="12">
                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered rounded-3 overflow-hidden"
                                              style={{
                                                borderCollapse: "collapse",
                                                width: "100%",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  {hmfData2.header.map(
                                                    (columnName, index) => (
                                                      <th
                                                        className=""
                                                        style={tableaustyles}
                                                        key={index}
                                                      >
                                                        {columnName}
                                                      </th>
                                                    )
                                                  )}
                                                  <th
                                                    className=""
                                                    style={{
                                                      background: "#555B21",
                                                      color: "white",
                                                      paddingTop: "5px",
                                                      paddingBottom: "5px",
                                                      width: "1%",
                                                    }}
                                                    key="Del"
                                                  ></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {formDonneesInvest.map(
                                                  (rowData) => (
                                                    <tr key={rowData.index}>
                                                      {Object.entries(
                                                        rowData
                                                      ).map(([key, value]) =>
                                                        key !== "id" &&
                                                        key !== "index" ? (
                                                          <td key={key}>
                                                            {key ===
                                                            "annee_id" ? (
                                                              <select
                                                                value={value}
                                                                name="annee_id"
                                                                className="form-control form-control-sm"
                                                                onChange={(e) =>
                                                                  handleInputInvestChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              >
                                                                {renderAnneeOptions()}
                                                              </select>
                                                            ) : key ===
                                                              "monteur" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                type="text"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "base_eligible" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                type="number"
                                                                step="0.1"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : key ===
                                                              "designation" ? (
                                                              <input
                                                                className="form-control form-control-sm"
                                                                type="text"
                                                                defaultValue={
                                                                  value
                                                                }
                                                                name={key}
                                                                onChange={(e) =>
                                                                  handleInputInvestChange(
                                                                    rowData.index,
                                                                    e.target
                                                                      .name,
                                                                    e.target
                                                                      .value
                                                                  )
                                                                }
                                                              />
                                                            ) : (
                                                              <span>
                                                                {value}
                                                              </span>
                                                            )}
                                                          </td>
                                                        ) : (
                                                          <td
                                                            className="d-none"
                                                            key={key}
                                                          >
                                                            <input
                                                              type="hidden"
                                                              value={value}
                                                            />
                                                          </td>
                                                        )
                                                      )}
                                                      <td>
                                                        <i
                                                          className="bx bx-trash"
                                                          style={{
                                                            fontSize: "20px",
                                                            paddingTop: "5px",
                                                            textAlign: "center",
                                                            verticalAlign:
                                                              "middle",
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() =>
                                                            onDeleteFormDonneesInvest(
                                                              rowData.index
                                                            )
                                                          }
                                                        ></i>
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                                <tr>
                                                  <td colSpan="9">
                                                    <input
                                                      type="button"
                                                      style={tableaustyles}
                                                      className="btn btn-info mt-3 mt-lg-0"
                                                      value="Ajouter"
                                                      onClick={
                                                        onAddFormDonneesInvest
                                                      }
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </Col>
                                      </CardBody>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
